module.exports = __webpack_public_path__ + "static/media/contactFive.36ba44f1.png";